import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=010d0c11&scoped=true&"
import script from "./NotificationSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSettings.vue?vue&type=style&index=0&id=010d0c11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010d0c11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('010d0c11')) {
      api.createRecord('010d0c11', component.options)
    } else {
      api.reload('010d0c11', component.options)
    }
    module.hot.accept("./NotificationSettings.vue?vue&type=template&id=010d0c11&scoped=true&", function () {
      api.rerender('010d0c11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/profile/NotificationSettings.vue"
export default component.exports